import { Component, Binding } from '../annotations';

@Component({
	selector: 'carousel',
	template: require('./carousel.html'),
	style: require('./carousel.scss')
})
export class Carousel {
	@Binding('<') templates: string[];
	index: number = 0;

	previousTemplate(): void {
		this.index = ((this.index - 1) + this.templates.length) % this.templates.length;
	}

	nextTemplate(): void {
		this.index = (this.index + 1) % this.templates.length;
	}
}


/** WEBPACK FOOTER **
 ** ./app/common/carousel.ts
 **/